import { AxiosInstance } from 'axios';

export abstract class AxiosRepository {
  public constructor(protected axiosClient: AxiosInstance, authClient?: AxiosInstance) {
    this.axiosClient.defaults.headers = {
      ...axiosClient.defaults.headers,
      ...(authClient ? authClient?.defaults.headers : {}),
    };

    // re-applies the interceptors, rather then assigning the reference
    // to the ui-auth client interceptors
    if (authClient) {
      (authClient.interceptors.request as any).handlers.forEach((arg: any) => {
        axiosClient.interceptors.request.use(arg.fulfilled, arg.rejected);
      });
      (authClient.interceptors.response as any).handlers.forEach((arg: any) => {
        axiosClient.interceptors.response.use(arg.fulfilled, arg.rejected);
      });
    }
  }

  protected get = this.axiosClient.get;
  protected patch = this.axiosClient.patch;
  protected post = this.axiosClient.post;
  protected postForm = this.axiosClient.postForm;
  protected put = this.axiosClient.put;
  protected delete = this.axiosClient.delete;
  protected options = this.axiosClient.options;
}
